export default __webpack_public_path__ + "static/media/KUN-BUSD.e367212a.svg";